import Dmytro from './team/Dmitry.jpg';
import Artem from './team/Artem.jpg';
import Svitlana from './team/Svitlana.jpg';
import Victor from './team/Viktor.jpg';
import Yevhenii from './team/Yevhenii.jpg';
import Serhey from './team/Serhey.jpg';
import Lana from './team/LanaTrotsenko.jpg';
import VictorKarnydal from './team/VictorKarnydal.jpg';
import KonstantinLigus from './team/KonstantinLigus.jpg';
import Galina from './team/Galina.jpg';
import Mykola from './team/Mykola.jpg';

export const teams = [
  {
    id: 1,
    username: 'Dmytro Kniahnytskyi',
    role: 'Team Lead',
    avatar: Dmytro,
    linkedin: 'https://www.linkedin.com/in/dmitry-knyagnitskiy-711b55209/',
    github: 'https://github.com/dimak911',
  },

  {
    id: 2,
    username: 'Yevhenii Kobets',
    role: 'Scrum',
    avatar: Yevhenii,
    linkedin: 'https://www.linkedin.com/in/yevhenii-kobets-900796239/',
    github: 'https://github.com/eugene17kotov',
  },

  {
    id: 3,
    username: 'Sergei Smirnov',
    role: 'Developer',
    avatar: Serhey,
    linkedin: 'https://www.linkedin.com/in/sergey-smirnov-9123a623b/',
    github: 'https://github.com/morysol',
  },

  {
    id: 4,
    username: 'Svitlana Сhudesa',
    role: 'Developer',
    avatar: Svitlana,
    linkedin: 'https://www.linkedin.com/in/svitlana-chudesa-55273a21a/',
    github: 'https://github.com/veta41',
  },

  {
    id: 5,
    username: 'Artem Makhov',
    role: 'Developer',
    avatar: Artem,
    linkedin: 'https://www.linkedin.com/in/artem-makhov/',
    github: 'https://github.com/ArtemMakhov',
  },

  {
    id: 6,
    username: 'Victor Radchenko',
    role: 'Developer',
    avatar: Victor,
    linkedin: 'https://www.linkedin.com/in/viktor-radchenko-goit/',
    github: 'https://github.com/Victor8825',
  },

  {
    id: 7,
    username: 'Svitlana Trotsenko',
    role: 'Developer',
    avatar: Lana,
    linkedin: 'https://www.linkedin.com/in/svetlana-trotsenko',
    github: 'https://github.com/LanaLem',
  },

  {
    id: 8,
    username: 'Viсtor Karnydal',
    role: 'Developer',
    avatar: VictorKarnydal,
    linkedin: 'https://www.linkedin.com/in/viktor-karnydal/',
    github: 'https://github.com/Karnydal?tab=repositories',
  },

  {
    id: 9,
    username: 'Mykola Kondratiuk',
    role: 'Developer',
    avatar: Mykola,
    linkedin: 'https://www.linkedin.com/in/mykola-kondratiuk-a85991228/',
    github: 'https://github.com/Mykola28112002',
  },

  {
    id: 10,
    username: 'Konstantin Ligus',
    role: 'Developer',
    avatar: KonstantinLigus,
    linkedin:
      'https://www.linkedin.com/in/konstantin-ligus-java-script-developer',
    github: 'https://github.com/KonstantinLigus',
  },

  {
    id: 11,
    username: 'Galina Stepanovich',
    role: 'Developer',
    avatar: Galina,
    linkedin:
      'https://www.linkedin.com/in/%D0%B3%D0%B0%D0%BB%D0%B8%D0%BD%D0%B0-%D1%81%D1%82%D0%B5%D0%BF%D0%B0%D0%BD%D0%BE%D0%B2%D0%B8%D1%87-202aa825b/',
    github: 'https://github.com/HalynaStep',
  },
];
